export const LOGIN = {
	emailForm: 'login-email-form',
	googleButton: 'login-google-button',
	emailInput: 'login-email-input',
	sendButton: 'login-send-code-button',
	emailMessage: 'login-email-message',
	codeForm: 'login-code-form',
	sentTo: 'login-sent-to',
	codeInput: 'login-code-input',
	verifyButton: 'login-verify-button',
	backButton: 'login-back-button',
	resendButton: 'login-resend-button',
	codeMessage: 'login-code-message',
};

export const DASHBOARD = {
	frame: 'dashboard-frame',
	loading: 'dashboard-loading',
	empty: 'dashboard-empty',
	statusToggle: 'dashboard-status-toggle',
	statusPanel: 'dashboard-status-panel',
	statusResult: 'dashboard-status-result',
	statusLastSuccess: 'dashboard-status-last-success',
	statusNextRun: 'dashboard-status-next-run',
	statusWarnings: 'dashboard-status-warnings',
	refreshButton: 'dashboard-refresh-button',
	refreshMessage: 'dashboard-refresh-message',
	runRow: 'dashboard-run-row',
	runLog: 'dashboard-run-log',
	signOut: 'dashboard-sign-out-link',
	closePanel: 'dashboard-status-close',
};
